// extracted by mini-css-extract-plugin
export default {"button":"logout_button__b43wF"};